import { ReportComponentConfig } from '@/types/api/modules/business-intelligence';

import { ConnectedAccount } from './ConnectedAccount';
import { Report } from './Report';

export enum ReportComponentType {
    // Content
    TITLE = 'Title',
    DESCRIPTION = 'Description',
    DIVIDER = 'Divider',
    IMAGE = 'Image',
    VIDEO = 'Video',
    AUDIO = 'Audio',
    // Data Visualization
    STATISTIC = 'Statistic',
    MULTIPLE_STATISTICS = 'Multiple Statistics',
    TABLE = 'Table',
    MAP = 'Map',
    GLOBE = 'Globe',
    COUNTERCYCLICAL_VANTAGE = 'Vantage',
    // Charts
    FUNNEL_CHART = 'Funnel Chart',
    SANKEY_CHART = 'Sankey Chart',
    HEAT_MAP = 'Heat Map',
    SCATTER_PLOT = 'Scatter Plot',
    BAR_CHART = 'Bar Chart',
    GAUGE_CHART = 'Gauge Chart',
    DONUT_CHART = 'Donut Chart',
    PIE_CHART = 'Pie Chart',
    AREA_CHART = 'Area Chart',
    LINE_CHART = 'Line Chart',
    RADAR_CHART = 'Radar Chart',
    RADIAL_CHART = 'Radial Chart',
    CHORD_CHART = 'Chord Chart',
    // Embeds
    EMBED = 'Embed',
    YOUTUBE = 'YouTube',
    LOOM = 'Loom',
    VIMEO = 'Vimeo',
    GOOGLE_CALENDAR = 'Google Calendar',
    MICROSOFT_OUTLOOK_CALENDAR = 'Microsoft Outlook Calendar',
    GOOGLE_DRIVE = 'Google Drive',
    GOOGLE_DOCS = 'Google Docs',
    GOOGLE_SHEETS = 'Google Sheets',
    MICROSOFT_ONEDRIVE = 'Microsoft OneDrive',
    DROPBOX = 'Dropbox',
    BOX = 'Box',
    NOTION = 'Notion',
    GITHUB = 'GitHub',
    HEX = 'Hex',
    CONFLUENCE = 'Confluence',
    MIRO = 'Miro',
    LUCID = 'Lucid',
    GRAPHY = 'Graphy',
    MICROSOFT_POWER_BI = 'Microsoft Power BI',
    LOOKER = 'Looker',
    TABLEAU = 'Tableau',
    ZOHO_ANALYTICS = 'Zoho Analytics',
}

export interface ReportComponent {
    id: string;
    report?: Report;
    index: number | undefined;
    tileX: number | undefined;
    tileY: number | undefined;
    tileWidth: number | undefined;
    tileHeight: number | undefined;
    name: string;
    description: string;
    type: ReportComponentType;
    configuration?: ReportComponentConfig;
    favorited: boolean;
    locked: boolean;
    archived: boolean;
    hidden: boolean;
    publiclyVisible: boolean;
    dataSource?: ConnectedAccount;
    embedURL: string;
    createdAt: Date;
    updatedAt: Date;
}
